"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFormatter = dateFormatter;
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formatter;

/**
 * Format date.
 * @param value we assume that this as a Z to tell us its a UTC timestamp. This will convert to local.
 * @param locale if not provided, will load from state.
 * @returns 
 */
function dateFormatter(value, locale) {
  var config = _Core["default"].getState().config;

  // get locale from state if not present in the call. can vary.
  if (!locale) {
    locale = config.locale;
  }
  if (Intl && Intl.DateTimeFormat) {
    // only create formatter first time
    if (!formatter) {
      locale = locale.replace("_", "-");
      formatter = new Intl.DateTimeFormat(locale, {
        dateStyle: 'short',
        timeStyle: 'short'
      });
    }
    return formatter.format(new Date(value));
  }
  //todo handle no INTL, right now we just return the value... 98% support on intl

  // we dont do anything if we dont have intl
  return value;
}
//# sourceMappingURL=dateFormatter.js.map